export default __webpack_public_path__ + "static/media/redirectBlue.19b3a504.svg";